import * as React from 'react';
import S, { DataSignal } from 's-js';
import * as $ from 'jquery';
import { SuperCriticalComponent, SuperCriticalReference } from 'lib/supercritical';

export class PCColumnLayoutTrigger {
    signal : DataSignal<null>;
    ref : (e : HTMLElement | null) => void;

    constructor() {
        this.signal = S.data(null);
        this.ref = e => this.signal(null);
    }
}

export interface PCColumnLayoutProps {
    additionalTrigger? : PCColumnLayoutTrigger;
    gutterPx? : number;
    className? : string;
    children? : any;
}

export class PCColumnLayout extends SuperCriticalComponent<PCColumnLayoutProps> {
    ref : (e : HTMLDivElement | null) => void;

    constructor(props : PCColumnLayoutProps) {
        super(props);
        this.ref = SuperCriticalReference(this, LayoutPanels);
    }

    srender(props : PCColumnLayoutProps) : React.ReactElement<any> {
        return (
            <div className={'pc-columnlayout ' + props.className} ref={this.ref}>
                {props.children}
            </div>
        );
    }
}

function LayoutPanels(props : PCColumnLayoutProps, el : HTMLDivElement) {
    // DC 06/08/2021 -- Updating this feature from 'lib/S' to 's-js' broke something with auto-resize after data loads.
    // Not sure if it's the OrgUsersView or OrgListView that triggers the layout update, but I think it has something to do with "default" behaviors.
    // At first I tried putting a timer on the 'load', 'hashchange', and 'keyup' events so I could force a resize thru 'scroll'. 
    // Added a timer on S's additional triggers, i.e. OrgUsersView I think, and it seems to do the job.
    window.addEventListener('resize', PerformLayout);
    S.cleanup(() => window.removeEventListener('resize', PerformLayout));

    S(() => {
        props.additionalTrigger && props.additionalTrigger.signal();
        setTimeout(PerformLayout, 300);
    });

    function PerformLayout() {
        if (!el.children.length) return;
        let containerWidth = el.offsetWidth,
            $el = $(el),
            columnItems = $el.children(),
            colWidth = columnItems[0].offsetWidth,
            gutter = props.gutterPx || 0,
            colCount = Math.floor(containerWidth / (colWidth + gutter)),
            columns = [] as number[];

        for (let i = 0; i < colCount; i++) {
            columns.push(gutter);
        }

        for (let i = 0; i < columnItems.length; i++) {
            let min = Math.min(...columns),
                index = columns.indexOf(min),
                leftPos = index * (colWidth + gutter),
                item = columnItems[i];

            $(item).css('position', 'absolute')
                .css('top', min + 'px')
                .css('left', leftPos + 'px');
            columns[index] = min + item.offsetHeight + gutter;
        }

        let max = Math.max(...columns);
        $el.css('height', max + 'px');
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/pccolumnlayout/view.tsx